import { Link } from 'react-router-dom'
import Tooltip from '../../Tooltip/Tooltip'
import {
  Label,
  ExpandedContent,
  IconLabelGroup,
  CollapsedContent,
  Arrow,
  MenuItemContainer,
  TextContainer,
} from './MenuItem.styled'

interface MenuItemUIProps {
  isCollapsed: boolean
  isActive: boolean
  label: string
  icon: React.ReactElement
  children?: React.ReactNode
  linkPath: string
  isExpanded: boolean
  onLinkClick: (e: React.MouseEvent) => void
  onToggle?: () => void
}

export const MenuItemUI = ({
  isCollapsed,
  isActive,
  label,
  icon,
  children,
  linkPath,
  isExpanded,
  onLinkClick,
  onToggle,
}: MenuItemUIProps) => {
  return (
    <Link to={linkPath} onClick={onLinkClick}>
      <MenuItemContainer $isCollapsed={isCollapsed} $isActive={isActive} onClick={onToggle}>
        {isCollapsed ? (
          <Tooltip type="dark" place="right" text={label}>
            <CollapsedContent $isActive={isActive}>{icon}</CollapsedContent>
          </Tooltip>
        ) : (
          <ExpandedContent $isActive={isActive}>
            {children ? (
              <>
                <IconLabelGroup>
                  {icon}
                  <TextContainer>
                    <Label>{label}</Label>
                  </TextContainer>
                </IconLabelGroup>
                <Arrow>{isExpanded ? '▲' : '▼'}</Arrow>
              </>
            ) : (
              <IconLabelGroup>
                {icon}
                <TextContainer>
                  <Label>{label}</Label>
                </TextContainer>
              </IconLabelGroup>
            )}
          </ExpandedContent>
        )}
      </MenuItemContainer>
    </Link>
  )
}

export default MenuItemUI
